/**
 * This is a React component that displays a slider of top categories and allows the user to filter
 * products by clicking on a category.
 * @returns The TopCategoriesComponent JSX code is being returned.
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import { useDispatch, useSelector } from "react-redux";
import { getCategoriesFilterAction } from "../../State/actions/CategoriesFilterAction";
import { defaultCategory } from "../../utils/productUtils/ProductUtils";

const TopCategoriesComponent = () => {
  const topCategories = useSelector((state) => state.topCategories);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const addCategoriesFilter = (id, categoryName) => {
    dispatch(getCategoriesFilterAction(id, categoryName));
    if (window.innerWidth <= 768) {
      navigate(`/category/${id}`);
    } else {
      navigate(`/shop/${id}`, { replace: true });
    }
  };

  const sliderSettings = {
    slidesToShow: topCategories.length <= 4 ? 4 : 5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    speed: 300,
    infinite: topCategories.length <= 4 ? false : true,
    autoplaySpeed: 2000,
    autoplay: true,
            responsive: [
      {
        breakpoint: 2400,
        settings: {
          slidesToShow: topCategories.length <= 5 ? 5 : 6,
        },
      },
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: topCategories.length <= 5 ? 5 : 6,
        },
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: topCategories.length <= 5 ? 5 : 6,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
    <>
      {topCategories.length > 0 && (
        <div className="topOfferWrapper container p-lg-3 p-sm-2 mt-3">
          <div className="col-12">
            <div className="col-12 text-start productWrapper">
              <h1 className="fs-6 fw-bolder lh-base">Top Categories</h1>
            </div>
          </div>
          <div id="top_categories_home" className="my-slider">
            <Slider {...sliderSettings}>
              {topCategories.map((categoriesVo, index) => (
                <div
                  className="col-sm-6 slides"
                  key={index}
                  onClick={() =>
                    addCategoriesFilter(
                      categoriesVo.categoryid,
                      categoriesVo.categoryname
                    )
                  }
                  style={{ cursor: "pointer" }}
                >
                  <div className="topOfferSliderImage">
                    <img
                      src={categoriesVo.logo || defaultCategory}
                      alt={categoriesVo.categoryname}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = defaultCategory;
                      }}
                      id={`categorieId${categoriesVo.categoryid}`}
                      width="130"
                      height="130"
                      loading="lazy"
                    />
                  </div>
                    <h4
                      className="fs-6 fw-normal text-capitalize text-center trunk mt-2 w-75 mx-auto"
                      style={{"color" : "#000"}}
                      dangerouslySetInnerHTML={{
                        __html: categoriesVo.categoryname,
                      }}
                    ></h4>
                    
                </div>
              ))}
            </Slider>
          </div>
        </div>
      )}
    </>
  );
};

export default TopCategoriesComponent;
